import { createAction } from '@reduxjs/toolkit';

export default createAction('adjustLocation', locationId => ({
  payload: {
    locationId,
  },
}));
